/**
 * Fields on users/{uid} that only the backend sets (Persona webhook, Stripe handler, admin review).
 * Firestore rules reject any client write that changes them, so they are never sent from the app.
 */
export const SERVER_ONLY_USER_FIELDS = [
  'isVerified',
  'dateVerified',
  'verifyContext',
  'stripeCustomerId',
  'isFlagged',
];

/**
 * Returns a copy of a profile without the server-owned fields. The app saves the whole profile object it
 * last read; if that copy is stale (e.g. Persona finished while the form was open) sending isVerified would
 * be rejected by the rules, or with older rules would overwrite the server's value.
 */
export const withoutServerOnlyUserFields = <T extends Record<string, any>>(data: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(data ?? {}).filter(([key]) => !SERVER_ONLY_USER_FIELDS.includes(key)),
  ) as Partial<T>;
